export const PayoutBeneficiaryFilters = {
  MY_COMPANY: 'my-company',
  BUSINESS: 'business',
  INDIVIDUAL: 'individual',
}

export type PayoutBeneficiaryFilter =
  (typeof PayoutBeneficiaryFilters)[keyof typeof PayoutBeneficiaryFilters]

export const MAX_GBP_PAYMENT_AMOUNT = 1000000

export const FeeErrors = {
  BVNK_0000: 'bvnk:0000',
  BVNK_PAYMENT_0001: 'bvnk:payment:0001',
}

export const IBAN_PATTERN = /^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/

export const FIAT_SEND_ERRORS = {
  INSUFFICIENT_BALANCE: 'INSUFFICIENT_BALANCE',
  PAYMENT_NOT_SUPPORTED: 'PAYMENT_NOT_SUPPORTED',
} as const

export const FIAT_SEND_EOF = {
  SUCCESS: 'SUCCESS',
  APPROVAL: 'APPROVAL',
} as const

export const PAYOUT_VERSIONS = {
  LEGACY_WITHDRAW: 'LEGACY_WITHDRAW',
  LEGACY_PAY: 'LEGACY_PAY',
  UNIFIED_PAYOUT_V2: 'UNIFIED_PAYOUT_V2',
} as const
